import { LoadableAfterPaint } from '@confluence/loadable';

export const PopularLabelsMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PopularLabelsMacro" */ '../src/PopularLabelsMacroRenderer.tsx'
			)
		).PopularLabelsMacroRenderer,
});
